<template>
  <div>
    <div id="container" ref="containerrr">
      <div class="div-block-2">
        <img src="/static/hilab.png" alt class="image" />
        <div class="div-block-3">
          <div class="div-block-5">
            <div
              class="div-block-4 progressindicatorstep"
              v-for="(section, i) in surveyJSON"
              :key="i"
            >
              <div class="div-block-7">
                <div
                  class
                  :class="[i == (surveyJSON.length - 1) ? 'progressbar3' : (i == 0 ? 'progressbar1' : 'progressbar2')]"
                ></div>
                <div class="section-step-icon">
                  <div v-if="i > stepSection" class="section-step-number">{{ i + 1 }}</div>
                  <button v-if="i <= stepSection" @click="didPressGoBackToSection(i)">
                    <img src="/static/green_check.png" height="24" width="24" alt class />
                  </button>
                </div>
              </div>
              <div
                :class="[i <= stepSection ? 'progressindicatorlabelactive' : 'progressindicatorlabel']"
              >{{ section.title }}</div>

              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="step">
        <Survey
          ref="survey"
          :quiz="quizQuestion"
          @duplicatePreviousQuestion="handleDuplicatePreviousQuestion"
        />
      </div>
      <div v-if="!virtualKeyboardIsOn" class="bottom-buttons-container">
        <div class="bottom-buttons alignleft">
          <button @click="openPrevious()">
            <img src="/static/button-back.png" />
          </button>
        </div>
        <div v-if="!hasNextQuestion" class="bottom-buttons finish">
          <v-btn @click="save()" color="#00BFB3">CONCLUIR</v-btn>
        </div>
        <div v-if="hasNextQuestion" class="bottom-buttons alignright">
          <button @click="openNext()">
            <img src="/static/button-next.png" />
          </button>
        </div>
      </div>
    </div>
    <div class="div-block copyrightfooter">
      <div class="text-block">Copyright © 2019 Hi Technologies, All Rights Reserved.</div>
    </div>
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="loading">
        <h3>{{ loadingMessage }}</h3>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../router";
import Survey from "@/components/Survey.vue";
import Moment from "moment-timezone";
import axios from "axios";
import * as SurveyJSON from "../assets/survey.json";

export default {
  name: "form-manager",
  components: {
    Survey
  },
  data() {
    return {
      surveyJSON: SurveyJSON,
      quizSection: null,
      quizQuestion: null,
      stepSection: 0,
      stepQuestion: 0,
      dynamicKeys: {},
      loading: false,
      loadingMessage: "",
      virtualKeyboardIsOn: false
    };
  },
  created() {
    this.setStep(0);
    this.setQuestion(true);
    document.addEventListener("focusin", this.focusIn);
    document.addEventListener("focusout", this.focusOut);
  },
  beforeDestroy() {
    document.removeEventListener("focusin", this.focusIn);
    document.removeEventListener("focusout", this.focusOut);
  },
  computed: {
    hasNextQuestion() {
      return !(
        this.stepQuestion >= this.quizSection.sections.length - 1 &&
        this.stepSection >= this.surveyJSON.length - 1
      );
    }
  },
  methods: {
    focusIn() {
      if (event.target.tagName == "BUTTON") {
        return;
      }
      this.virtualKeyboardIsOn = /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    focusOut() {
      this.virtualKeyboardIsOn = false;
    },
    handleDuplicatePreviousQuestion(question) {
      for (
        var index = 0;
        index <
        this.surveyJSON[this.stepSection].sections[this.stepQuestion].questions
          .length;
        index++
      ) {
        if (
          question.targetId ==
          this.surveyJSON[this.stepSection].sections[this.stepQuestion]
            .questions[index].id
        ) {
          let targetQuestion = {
            ...this.surveyJSON[this.stepSection].sections[this.stepQuestion]
              .questions[index]
          };

          targetQuestion.id = targetQuestion.id + this.randomize(10);
          targetQuestion.answer = "";

          let questionIndex =
            this.surveyJSON[this.stepSection].sections[this.stepQuestion]
              .questions.length - 1;
          this.surveyJSON[this.stepSection].sections[
            this.stepQuestion
          ].questions.splice(questionIndex, 0, targetQuestion);

          this.setStep(this.stepQuestion, true);

          break;
        }
      }
    },
    didPressGoBackToSection(section) {
      this.stepSection = 0;
      this.setStep(null, false);
    },
    openPrevious() {
      if (this.stepQuestion <= 0) {
        if (this.stepSection > 0) {
          this.stepSection -= 1;
          this.setStep(null, false);
        }

        return;
      }

      this.stepQuestion -= 1;
      this.setQuestion(false);
    },
    openNext(forceNext) {
      if (
        this.$refs.survey.canProceed() === false ||
        (forceNext && !forceNext)
      ) {
        return;
      }

      var openNextMechanic = () => {
        if (this.stepQuestion >= this.quizSection.sections.length - 1) {
          if (this.stepSection >= this.surveyJSON.length - 1) {
            this.save();
          } else {
            this.stepSection += 1;
            this.setStep(0, true);
          }

          return;
        }

        this.stepQuestion += 1;
        this.setQuestion(true);
        this.scrollToTop();
      };

      if (this.quizQuestion.postAnswer) {
        // It demands a post answer procedure

        if (this.quizQuestion.postAnswer.type == "connectToServer") {
          this.loading = true;
          this.loadingMessage =
            "Comparando com as últimas atualizações do Ministério da Saúde...";
          axios
            .post(
              "https://hilab.azurewebsites.net/app/rest/" +
                this.quizQuestion.postAnswer.endpoint,
              this.extractVerifyFilterParams(this.quizQuestion.postAnswer)
            )
            .then(response => {
              this.loading = false;

              var key = this.quizQuestion.postAnswer.key;
              this.dynamicKeys[key] = response.data["result"];

              openNextMechanic();
            })
            .catch(error => {
              this.loading = false;
              openNextMechanic();
            });
        }
      } else {
        openNextMechanic();
      }
    },
    save() {
      console.log(this.extractFinalForm());
      this.loading = true;
      this.loadingMessage = "Estimando seus exames recomendados...";
      axios
        .post(
          "https://hilab.azurewebsites.net/app/rest/recommendation/getResult",
          {
            name: sessionStorage.getItem("name"),
            document: sessionStorage.getItem("document"),
            email: sessionStorage.getItem("email"),
            profile: this.extractFinalForm()
          }
        )
        .then(response => {
          console.log(response);
          this.loading = false;

          if (window.webkit) {
            window.webkit.messageHandlers.handler.postMessage("CLOSE_SURVEY");
          }

          if (app.onRecommendationFinished) {
            app.onRecommendationFinished();
          }

          let examName = response.data["name"];
          let commercialExamName = response.data["commercial_name"];
          let recommendationLink = response.data["link"];
          let recommendationDetails = response.data["recommendation"];
          let recommendationAmount = response.data["recommendations"];

          sessionStorage.setItem("mainExamLink", recommendationLink);
          sessionStorage.setItem("mainExamName", commercialExamName);
          sessionStorage.setItem("mainExamDetails", recommendationDetails);
          sessionStorage.setItem("recommendationsAmount", recommendationAmount);

          router.push({
            name: "Resultado",
            params: {
              amountOfRecommendations: recommendationAmount,
              mainRecommendationLink: recommendationLink,
              mainRecommendationName: commercialExamName,
              mainRecommendationExplanation: recommendationDetails
            }
          });
        })
        .catch(error => {
          this.loading = false;
        });
    },
    setStep(index, movingForward) {
      const vm = this;

      vm.quiz = {};

      vm.quizSection = vm.surveyJSON[this.stepSection];

      if (index == null) {
        this.stepQuestion = vm.quizSection.sections.length - 1;
      } else {
        this.stepQuestion = index;
      }

      this.setQuestion(movingForward);

      return;
    },
    setQuestion(movingForward) {
      const vm = this;
      vm.quizQuestion = vm.quizSection.sections[this.stepQuestion];

      for (var question of vm.quizQuestion.questions) {
        var filters = question.filter;
        if (filters != null) {
          for (var filter of filters) {
            let mustRemove = !this.matchFilters(filter);
            if (mustRemove) {
              movingForward ? this.openNext(true, true) : this.openPrevious();
              return;
            }
          }
        }
      }

      return;
    },
    matchFilters(filter) {
      for (var step of this.surveyJSON) {
        for (var section of step.sections) {
          for (var question of section.questions) {
            if (question.id == filter.id) {
              if (filter.operator) {
                if (filter.operator === "older") {
                  return this.extractAgeFrom(question.answer) >= filter.answer;
                }
              }
              return question.answer == filter.answer;
            }
          }
        }
      }

      if (filter.verify) {
        return this.dynamicKeys[filter.verify] == filter.expect;
      }

      return false;
    },
    extractVerifyFilterParams(filter) {
      var response = [];

      if (filter.paramsFrom) {
        for (var step of this.surveyJSON) {
          for (var section of step.sections) {
            for (var question of section.questions) {
              var regex = new RegExp("^(" + filter.paramsFrom + ")[\\D\\w]*$");
              if (regex.test(question.id)) {
                response.push(question.answer);
              }
            }
          }
        }
      }

      return response;
    },
    extractFinalForm() {
      var finalForm = {};
      for (var step of this.surveyJSON) {
        for (var section of step.sections) {
          for (var question of section.questions) {
            var filters = question.filter;
            var wasShown = true;

            if (filters != null) {
              for (var filter of filters) {
                wasShown = wasShown && this.matchFilters(filter);
              }
            }

            if (wasShown && question.key) {
              if (question.keyModifier) {
                if (question.keyModifier == "calculate_age") {
                  finalForm[question.key] = this.extractAgeFrom(
                    question.answer
                  );
                } else if (question.keyModifier == "append") {
                  if (finalForm[question.key]) {
                    finalForm[question.key].push(question.answer);
                  } else {
                    finalForm[question.key] = [question.answer];
                  }
                }
              } else {
                finalForm[question.key] = question.answer;
              }
            } else {
              if (question.type == "check_box") {
                for (var option of question.options) {
                  finalForm[option.key] = option.selected;
                }
              }
            }
          }
        }
      }

      console.log(finalForm);

      return finalForm;
    },
    extractAgeFrom(value) {
      return Moment().diff(Moment(value, "DDMMYYYY"), "years");
    },
    randomize(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    scrollToTop() {
      var scrollOptions = {
        left: 0,
        top: 0,
        behavior: "smooth"
      };

      this.$refs.containerrr.parentElement.scrollTo(scrollOptions);
    }
  }
};
</script>
<style lang="scss">
#container {
  min-height: calc(100vh - 40px);
}
.bottom-buttons-container {
  display: flex;
  position: fixed;
  width: 80vw;
  bottom: 45px;
  left: 10vw;
  right: 10vw;
}
@media (max-width: 991px) {
  div.step {
    padding-bottom: 120px;
  }
  .bottom-buttons-container {
    background: linear-gradient(#fff0, #ffffffbf);
    display: flex;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    padding-left: calc(10vw + 10px);
    padding-right: calc(10vw + 10px);
  }

  .bottom-buttons.alignleft {
    margin-right: calc(50% - 80px) !important;

    button {
      margin-left: 0px !important;
      height: 80px !important;
      width: 80px !important;
    }
  }

  .bottom-buttons.alignright {
    margin-left: calc(50% - 80px) !important;

    button {
      margin-left: 0px !important;
      height: 80px !important;
      width: 80px !important;
    }
  }

  .bottom-buttons.finish {
    bottom: 80px;
    height: 45px !important;
    width: 100px !important;
  }

  .bottom-buttons {
    bottom: 80px;
    height: 80px !important;
    width: 80px !important;
  }
}
button {
  outline: none !important;
}

.bottom-buttons.alignleft {
  margin-right: calc(50% - 80px);

  button {
    margin-left: -80px;
  }
}

.bottom-buttons.alignright {
  margin-left: calc(50% - 80px);

  button {
    margin-left: 80px;
  }
}
.bottom-buttons.finish {
  height: 50px;
  width: 80px;
  margin: 15px 15px auto;

  > button {
    color: white;
    font-weight: 700;
  }
}

.bottom-buttons {
  position: flex;
  bottom: 60px;
  height: 80px;
  width: 80px;
  display: inline-grid;

  button {
    width: 100%;
    height: 100%;
    border: none !important;
    padding: 0 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media (min-width: 991px) {
  .bottom-buttons-container {
    bottom: 90px;

    .finish {
      margin-left: -50px;
    }
  }
}
.step {
  // max-height: calc(100vh - 170px);
  padding-right: 10vw;
  padding-left: 10vw;
  overflow-y: auto;
  overflow-x: hidden;
}

.container {
  max-width: none;
}

.w-checkbox {
  display: block;
  margin-bottom: 5px;
  padding-left: 20px;
}

.w-checkbox:before {
  content: " ";
  display: table;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  -ms-grid-row: 1;
  grid-row-start: 1;
}

.w-checkbox:after {
  content: " ";
  display: table;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  -ms-grid-row: 1;
  grid-row-start: 1;
  clear: both;
}

.w-checkbox-input {
  float: left;
  margin-bottom: 0px;
  margin-left: -20px;
  margin-right: 0px;
  margin-top: 4px;
  line-height: normal;
}

.w-pagination-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.w-pagination-previous {
  display: block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
  margin-right: 10px;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 20px;
  padding-left: 20px;
  background-color: #fafafa;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-color: #ccc;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
  border-left-color: #ccc;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
}

.w-pagination-previous-icon {
  margin-right: 4px;
}

.w-pagination-next {
  display: block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
  margin-right: 10px;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 20px;
  padding-left: 20px;
  background-color: #fafafa;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-color: #ccc;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
  border-left-color: #ccc;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
}

.w-pagination-next-icon {
  margin-left: 4px;
}

.div-block {
  left: 0%;
  top: auto;
  position: relative;
  right: 0%;
  bottom: 0%;
  background-color: #053541;
  text-align: center;
}

.text-block {
  padding-top: 12px;
  padding-bottom: 12px;
  font-family: Muli, sans-serif;
  color: #ececec;
  font-size: 11px;
}

.div-block-2 {
  position: relative;
  left: 0px;
  top: 0px;
  right: 0px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-bottom: 30px;
  padding-right: 170px;
  padding-left: 170px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 0.25fr 1fr;
  grid-template-columns: 0.25fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.div-block-3 {
  position: static;
  margin-top: 35px;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  -webkit-box-ordinal-group: 1;
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  color: #fff;
}

.image {
  position: absolute;
  left: 40px;
  top: 35px;
  right: auto;
  bottom: auto;
  height: 40px;
}

.progressindicatorlabel {
  padding-right: 10px;
  padding-left: 10px;
  font-family: Muli, sans-serif;
  color: #034151;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin-top: 5px;
}

.div-block-4 {
  display: block;
  min-width: 100px;
  clear: none;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.div-block-4.progressindicatorstep {
  display: block;
  min-width: 180px;
  margin-right: 0px;
  margin-left: 0px;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 12px;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
}

.section-step-number {
  background-color: #ffffff;
  color: #707070;
  border-radius: 12px;
}

.section-step-icon {
  position: static;
  display: block;
  width: 24px;
  height: 24px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
  float: none;
  clear: none;
  margin-right: auto;
  margin-left: auto;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;

  button {
    background: none;
    border: none;
    padding: 0 0;
  }
}

#container::after {
  content: " ";
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: -2;
  background-image: url("/static/fundo_verde@2x.png");
  background-position: 50% -23vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.div-block-5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.progressindicatorlabelactive {
  padding-right: 10px;
  padding-left: 10px;
  font-family: Muli, sans-serif;
  color: #034151;
  font-size: 16px;
  font-weight: 800;
  text-align: center;
  margin-top: 5px;
}

.progressbar2 {
  position: relative;
  left: 0%;
  top: 12px;
  right: 0px;
  z-index: -1;
  display: block;
  width: 100%;
  height: 1px;
  clear: none;
  background-color: #fff;
}

.div-block-7 {
  display: block;
  width: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.progressbar1 {
  position: relative;
  left: 50%;
  top: 12px;
  right: 0px;
  z-index: -1;
  display: block;
  width: 50%;
  height: 1px;
  clear: none;
  background-color: #fff;
}

.progressbar3 {
  position: relative;
  left: 0%;
  top: 12px;
  right: 0px;
  z-index: -1;
  display: block;
  width: 50%;
  height: 1px;
  clear: none;
  background-color: #fff;
}

.list-item {
  height: 80px;
  background-color: #d65f5f;
}

.section {
  overflow: auto;
  width: 100%;
  max-height: 78vh;
}

.heading {
  font-family: "Yanone Kaffeesatz", sans-serif;
  color: #034151;
  font-size: 50px;
  line-height: 55px;
  font-weight: 400;
}

.text-block-2 {
  font-family: Muli, sans-serif;
  color: #00bfb3;
  font-size: 13px;
}

.div-block-8 {
  margin-top: 15px;
}

.submit-button {
  margin-right: -83px;
  float: right;
  clear: none;
}

.form {
  display: -ms-grid;
  display: grid;
  margin-top: 25px;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  -ms-grid-rows: auto auto;
  grid-template-rows: auto auto;
}

.div-block-9 {
  min-height: 70px;
}

.textfield {
  height: 44px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px none #000;
  border-radius: 4px;
  background-color: #efefef;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.text-block-3 {
  font-family: Muli, sans-serif;
  color: #474747;
}

.field-label {
  margin-bottom: 0px;
  font-family: Muli, sans-serif;
  color: #c34241;
  font-size: 10px;
  font-weight: 400;
}

.radio-button-field {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 35px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.radio-button {
  width: 20px;
  height: 20px;
  margin-left: -10px;
}

.radio-button-label {
  margin-left: 25px;
  font-family: Muli, sans-serif;
  font-size: 21px;
  font-weight: 700;
}

.div-block-10 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 35px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.checkbox {
  width: 18px;
  height: 18px;
  margin-left: -10px;
}

.checkbox-label {
  margin-left: 25px;
  font-family: Muli, sans-serif;
  font-size: 21px;
  font-weight: 700;
}

.text-block-4 {
  margin-bottom: 5px;
  font-family: Muli, sans-serif;
  color: #474747;
}

.select-field {
  height: 44px;
  margin-bottom: 5px;
  border: 1px none #000;
  background-color: #efefef;
  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.05);
  font-family: Muli, sans-serif;
  color: #7c7c7c;
}

.checkbox-field {
  width: auto;
}

@media (max-width: 991px) {
  .div-block-3 {
    max-width: calc(100% - 20px);
    margin-top: 75px;
  }
  .div-block-4.progressindicatorstep {
    min-width: 0px;
    width: 35vw;
  }
  .progressindicatorlabelactive {
    font-weight: 900;
  }
  .progressindicatorlabelactive,
  .progressindicatorlabel {
    font-size: 10px;
    color: #034151;
  }
  #container::after {
    content: " ";
    position: absolute;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: -2;
    background-image: url("/static/fundo_verde@2x.png");
    background-position-y: -10%;
    background-position-x: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }
  .section-step-number {
    background-color: #eeeeee;
    color: #707070;
  }
  .progressbar3,
  .progressbar2,
  .progressbar1 {
    background-color: #eeeeee;
  }
}

@media (max-width: 991px) {
  .div-block-2 {
    height: 150px;
    padding: 10px 10px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .div-block-2 > img {
    top: 35px;
    left: 25px;
    height: 30px;
  }
  .container {
    padding-right: 20px;
    padding-left: 20px;
  }
}

@media (max-width: 479px) {
  .form {
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
  }
}

.loading {
  h3 {
    width: 300px;
    max-width: calc(100vw - 20px);
    margin: auto auto;
  }
  display: flex;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.75);
  position: absolute;
  top: 0;
  left: 0;
}
@media (max-width: 991px) {
  .step {
    padding-right: 10vw;
    padding-left: 10vw;
    padding-top: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FormManager.vue